export const ROLE_FOR_FILTER = [
    { name: "Clinic Executive", value: "clinic_executive" },
    { name: "Clinic Receptionist", value: "clinic_receptionist" },
    { name: "Clinic Doctor", value: "clinic_doctor" },
  ];

 export const STORE_TYPE = [
    { name: "Clinic", value: "clinic" },
    { name: "Store", value: "store" },
  ];